import { TRIGGER_TYPE } from '@mindtickle/actions-dropdown';
import { ICON_MAP } from '@mindtickle/icon';
import MenuActionLoader from '../../../../Shared/components/MenuActionLoader';
import { DEFAULT_HELP_SITE_URL, MENU_KEYS } from '../../../config/constants';
import { MIXPANEL_EVENTS } from '../../../mixpanel/config';
import messages from '../messages';
import { StyledHelpActionIcon } from '../style';
import { helpMenuConfigType } from '../type';
import { openUrl, trackAndHideAction } from './utils';

export const HELP_MENU_OPTIONS = ({
  company,
  onHideDropdownContent,
  isGetSupportInitialized,
  isEchoEnabled,
  isBerryChatDisabledForLearner,
  privacyPolicyLink,
  hideHelpSiteLink,
  isEchoWidgetLoaded,
  toggleEchoWidget,
  track,
  intl,
  openGetSupport,
}: helpMenuConfigType) => ({
  [MENU_KEYS.HELP_SITE]: {
    disabled: false,
    displayOrder: 1,
    key: MENU_KEYS.HELP_SITE,
    triggerType: TRIGGER_TYPE.FUNCTION,
    dataTestId: 'dropdown-help-and-support-center',
    hide: hideHelpSiteLink,
    content: (
      <>
        {intl.formatMessage(messages.SEARCH_HELP_DOCUMENTATION)}
        <StyledHelpActionIcon type={ICON_MAP['NEW-TAB']} />
      </>
    ),
    callFn: () => {
      trackAndHideAction({ track, onHideDropdownContent })(MIXPANEL_EVENTS.HELP_SITE);
      openUrl(company.helpSiteUrl || DEFAULT_HELP_SITE_URL)();
    },
  },
  [MENU_KEYS.GET_SUPPORT]: {
    displayOrder: 2,
    key: MENU_KEYS.GET_SUPPORT,
    triggerType: TRIGGER_TYPE.FUNCTION,
    dataTestId: 'dropdown-report-an-issue',
    content: !isGetSupportInitialized ? (
      <MenuActionLoader />
    ) : (
      <>
        {!isBerryChatDisabledForLearner || isEchoEnabled
          ? intl.formatMessage(messages.CONTACT_SUPPORT)
          : intl.formatMessage(messages.REPORT_ISSUE)}
      </>
    ),
    disabled: !isGetSupportInitialized,
    callFn: async () => {
      if (isEchoWidgetLoaded && isEchoEnabled) {
        toggleEchoWidget();
        trackAndHideAction({ track, onHideDropdownContent })(MIXPANEL_EVENTS.GET_SUPPORT);
        return;
      }
      await openGetSupport();
      trackAndHideAction({ track, onHideDropdownContent })(MIXPANEL_EVENTS.GET_SUPPORT);
    },
  },
  [MENU_KEYS.PRIVACY_POLICY]: {
    displayOrder: 4,
    key: MENU_KEYS.PRIVACY_POLICY,
    triggerType: TRIGGER_TYPE.FUNCTION,
    dataTestId: 'dropdown-privacy-policy',
    content: (
      <>
        {intl.formatMessage(messages.PRIVACY_POLICY)}
        <StyledHelpActionIcon type={ICON_MAP['NEW-TAB']} />
      </>
    ),
    callFn: () => {
      openUrl(privacyPolicyLink)();
      trackAndHideAction({ track, onHideDropdownContent })(MIXPANEL_EVENTS.PRIVACY_POLICY);
    },
  },
});
